<template>
  <div>
    <qc-dialog class="tc-15-rich-dialog cos operate-dialog" :show="innerShow" type="custom" :width="400"
      @close="closeDialog" :default-cancel="false" :append-to-body="true" :close-triggers="[]">

      <div class="operate-dialog-content">
        <div class="cos-tab-about-media">
          <div class="cos-tab-about-logo cos-tab-accound-logo">
            <img src="~@/assets/images/account.svg" alt="">
          </div>
          <div v-if="$store.IsQCloudCos">
            <div v-if="userInfo.Uin === userInfo.OwnerUin">
              <div class="cos-tab-account-id allow-user-select">
                {{$t('core.account_id')}}: {{userInfo.Uin}}</div>
            </div>
            <div v-else>
              <div class="cos-tab-account-id allow-user-select">
                {{$t('core.owner_account_id')}}: {{userInfo.OwnerUin}}</div>
              <div class="cos-tab-account-id allow-user-select">
                {{$t('core.sub_account_id')}}: {{userInfo.Uin}}</div>
            </div>
            <div class="cos-tab-account-id allow-user-select">
              APPID: {{userInfo.AppId}}</div>
          </div>

          <div class="cos-tab-account-id allow-user-select" v-if="!$store.IsQCloudCos">SecretID: {{secretId}}</div>
          <div class="cos-tab-account-btn cos-tab-about-btn">
            <qc-button type="weak" size="small" @click="logout">
              {{$t('core.logout')}}
            </qc-button>
          </div>
        </div>
      </div>

      <qc-button type="icon" :title="$t('core.close')" class="operate-dialog-close" @click="closeDialog">
        <qc-icon type="close"></qc-icon>
      </qc-button>

    </qc-dialog>

  </div>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';
import user from '@/scripts/helper/user';

export default {
  props: {
    show: {
      required: true,
      default: false,
    },
  },
  data() {
    return {
      secretId: '',
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    userInfo() {
      return this.$store.userInfo;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.getSecretId();
      }
    },
  },
  methods: {
    getSecretId() {
      this.secretId = '';
      if (!this.$store.IsQCloudCos) {
        user.getCredential().then(res => {
          this.secretId = res.SecretId;
        });
      }
    },
    logout() {
      eventProxy.emit('command.logout');
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
